import React, { useEffect, useState } from 'react';
import { ProductsRepurchaseList } from './ProductsRepurchaseList';
import { NavLink, useLocation } from 'react-router-dom';
import { i18n } from '../../lang/i18n';
import ProductsRowCategoryBlock from './ProductsRowCategoryBlock';
import ScrollToTop from '../../components/ScrollToTop';
import { useAppDispatch, useAppSelector } from '../../store/hooks';

export default function Products()
{
    const dispatch = useAppDispatch()
    const appData = useAppSelector((state) => state.appData)
    const locationCode = appData.location.code
    const location = useLocation();
    const [catIds, setCatIds] = useState<any>(undefined);
    //const [catTotals, setCatTotals] = useState(0);

    useEffect(() =>
    {
        processCatIds()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search]);

    function processCatIds()
    {
        let url = location.search === '' ? '' : location.search.substring(1);
        const qs = new URLSearchParams(url);
        if (qs.has('cat')) {
            let cats = qs.get('cat')?.split(',');
            if (cats) {
                //setCatTotals(cats.length)
                let catObs: any = {};
                for (let x = 0; x < cats.length; x++) {
                    catObs[cats[x]] = true;
                }
                setCatIds(catObs)
            }
        }
    }

    function renderCats(item: any, index: number)
    {
        if (catIds && !catIds[item.categoryId]) return null
        let blockClass = 'product-category ';
        if (index === 0) blockClass += ' product-category-top';
        else blockClass += index % 2 === 0 ? 'product-category-a' : 'product-category-b';
        return <div key={index} className={blockClass}>
            <ProductsRowCategoryBlock category={item} locationCode={locationCode} />
        </div>
    }
    return (
        <div className="products">
            <ScrollToTop />
            {appData.productsPurchased.length > 0 && <div className="product-category">
                <ProductsRepurchaseList items={appData.productsPurchased} dispatch={dispatch} locationCode={locationCode} />
            </div>}
            {appData.products.map(renderCats)}
            {catIds && <div className="container main-subtitle mt-1">
                <NavLink to={"/" + locationCode} className="btn-back link-btn" onClick={() => { setCatIds(undefined); }}> <i className="fa fa-home" /> {i18n._BTNs.GoHome}</NavLink>
            </div>}
        </div>
    )
}